const getApiBaseUrl = () => {
  // 개발/프로덕션 모두 nginx 프록시 경로 사용
  // setupProxy.js (개발) 또는 nginx-proxy.conf (프로덕션)가 /stock-db-api를 실제 서버로 프록시
  return '/stock-db-api/api/v1';
};

/**
 * 즐겨찾기 API 서비스 클래스
 */
export class FavoriteApiService {
  constructor(apiCall) {
    this.apiCall = apiCall;
    console.log('⭐ [FavoriteApiService] 생성됨, apiCall:', typeof apiCall);
  }

  async getFavorites() {
    const url = `${getApiBaseUrl()}/favorites`;
    console.log('⭐ [FavoriteApiService] getFavorites 호출:', url);
    return await this.apiCall(url, {
      method: 'GET',
    });
  }

  async addFavorite(stockCode) {
    const url = `${getApiBaseUrl()}/favorites`;
    console.log('⭐ [FavoriteApiService] addFavorite 호출:', url, stockCode);
    return await this.apiCall(url, {
      method: 'POST',
      body: JSON.stringify({ stock_code: stockCode }),
    });
  }

  async removeFavorite(stockCode) {
    const url = `${getApiBaseUrl()}/favorites/${stockCode}`;
    console.log('⭐ [FavoriteApiService] removeFavorite 호출:', url);
    return await this.apiCall(url, {
      method: 'DELETE',
    });
  }
}

/**
 * 즐겨찾기 API 서비스 인스턴스를 생성하는 함수
 */
export const createFavoriteApiService = (apiCall) => {
  return new FavoriteApiService(apiCall);
};
